import React from "react";
import { Tooltip, TooltipContent, TooltipTrigger } from "../ui/tooltip";

export default function TooltipWrapper({
  content,
  contentClassName = "",
  children,
  className = "",
  cursor = "cursor-default",
  position = "top",
}) {
  return (
    <Tooltip>
      <TooltipTrigger
        className={`${className ? className : "p-0 border-0 bg-none text-gray-500"} ${cursor && cursor}`}
      >
        {children}
      </TooltipTrigger>
      {content && (
        <TooltipContent className={contentClassName} side={position}>
          {content}
        </TooltipContent>
      )}
    </Tooltip>
  );
}
